import { Box, Heading, Text } from "@chakra-ui/react";
import React, { Children, PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

import menuStyles from "./Menu.module.css";
import menuExistingItemStyles from "./MenuExistingItemStyles.module.css";

const ExistingItemsContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={`${menuExistingItemStyles.Existing} ${menuStyles.SubMenu}`}>
      <Box as="hr" borderColor="brand.border" style={{ width: "100%", height: "1px" }} />
      <Heading as="h2" fontSize="16px" color="brand.analytic" fontWeight="bold" margin="2">
        <FormattedMessage id="existingItemsMenu.header" defaultMessage="Applied items" />
      </Heading>
      <div className={`${menuStyles.List} ${menuExistingItemStyles.List}`}>
        {children}
        {Children.count(children) === 0 ? (
          <Text fontSize="12px" color="brand.clear_creek" margin="0" fontStyle="italic">
            <FormattedMessage
              id="existingItemsMenu.no_existing_items_yet"
              defaultMessage="No applied items yet"
            />
          </Text>
        ) : null}
      </div>
    </div>
  );
};

export default ExistingItemsContainer;
